import { useQueryClient } from "@tanstack/react-query";
import { AlertTriangle, Check, LoaderCircle } from "lucide-react";
import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Brand } from "../components/Brand";

const SAFE_RETURN_PATHS = new Set(["/generate", "/artworks", "/pricing", "/account"]);

const ERROR_MESSAGES: Record<string, string> = {
  OAUTH_DENIED: "你取消了 KOOK 授权，GAMEFRAME 未读取任何账户信息。",
  OAUTH_CALLBACK_INVALID: "授权回调参数不完整，请重新发起登录。",
  OAUTH_STATE_MISMATCH: "授权请求与当前浏览器不匹配，请重新登录。",
  OAUTH_STATE_INVALID: "授权请求已过期或已使用，请重新登录。",
  KOOK_TOKEN_EXCHANGE_FAILED: "KOOK 授权服务暂时不可用，请稍后重试。",
  KOOK_USER_FETCH_FAILED: "无法读取 KOOK 基础用户信息，请重新授权。",
};

export function AuthResultPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const success = params.get("status") === "success";
  const requestedReturnTo = params.get("returnTo") || "/generate";
  const returnTo = SAFE_RETURN_PATHS.has(requestedReturnTo) ? requestedReturnTo : "/generate";
  const code = params.get("code") || "OAUTH_FAILED";

  useEffect(() => {
    if (!success) return;
    void queryClient.invalidateQueries({ queryKey: ["me"] });
    const timer = window.setTimeout(() => navigate(returnTo, { replace: true }), 900);
    return () => window.clearTimeout(timer);
  }, [success, returnTo, navigate, queryClient]);

  return (
    <main className="result-page">
      <Brand />
      <section className="result-card">
        <span className={success ? "result-symbol success" : "result-symbol error"}>{success ? <Check size={30} /> : <AlertTriangle size={30} />}</span>
        <p className="eyebrow">KOOK OAuth</p>
        <h1>{success ? "授权成功，欢迎回来。" : "这次授权没有完成"}</h1>
        <p>{success ? "正在恢复你的创作现场与生成参数…" : (ERROR_MESSAGES[code] ?? "登录暂时失败，请重新尝试。")}</p>
        {success ? <LoaderCircle className="spin" size={24} /> : <div className="result-buttons"><a className="button button-primary" href="/api/auth/kook?returnTo=%2Fgenerate">重新授权</a><Link className="button button-secondary" to="/generate">返回生成页</Link></div>}
      </section>
    </main>
  );
}
